import React from 'react';
import styled from '@emotion/styled';
import { AtlassianLogo } from '@atlaskit/logo';

import { TABLET_BREAKPOINT } from '../styled';

export const FormFooter = () => {
  return (
    <SignupWithEmailFormFooterContainer>
      <AtlassianLogo appearance="brand" />
    </SignupWithEmailFormFooterContainer>
  );
};

const SignupWithEmailFormFooterContainer = styled.div`
  margin-top: 50px;

  [role='img'] {
    height: 20px;
  }

  @media (min-width: ${TABLET_BREAKPOINT}) {
    margin-top: 148px;

    [role='img'] {
      height: 23px;
    }
  }
`;
